import React from 'react';
import _ from 'lodash';
import {
  // Api,
  Utils,
} from '@jesseteal/teal-react';

// const KNOWN_FOREIGN_KEYS = {
//   // field_name : table_name
//   docCategoryId: { table: 'docCategory', field: 'name' },
//   docDepartmentId: { table: 'docDepartment', field: 'department' },
// };

const AuditTableValue = ({ data, field }) => {
  // const client = Api.useClient();
  const [value, set_value] = React.useState('Loading...');

  const print = (obj, field) => {
    // if (KNOWN_FOREIGN_KEYS[field.column]) {
    //   // is a lookup value
    //   // const meta = KNOWN_FOREIGN_KEYS[field.column];
    //   // Api.query(client,`query getLookup{
    //   //   ${meta.table}{
    //   //     ${field.column}
    //   //     ${meta.field}
    //   //   }
    //   // }`).then(({ data: rows }) => {
    //   //   const all = _.find(rows[meta.table], { [field.column]: data[field.column] });
    //   //   if(all){
    //   //     set_value(all[meta.field])
    //   //   }
    //   // })
    //   return;
    // }
    // if (field.type === 'datetime') {
    //   set_value(Utils.date.format(obj[field.column], 'MM/dd/yyyy h:mm:ss a'));
    // } else if (field.type === 'date') {
    //   set_value(Utils.date.format(obj[field.column]));
    // } else {
    set_value(obj[field]);
    // }
  };

  React.useEffect(() => {
    console.log({ field, data });
    print(data, field);
  }, [data, field]); // eslint-disable-line
  return <>{value}</>;
};

export default AuditTableValue;
